import { useContext, useEffect } from 'react';
import { EventContext } from './EventContext';

export function useEvent(event: string, callback: () => void) {
  const { subscribe, unsubscribe } = useContext(EventContext);

  useEffect(() => {
    subscribe(event, callback);

    return () => unsubscribe(event, callback);
  }, [subscribe, unsubscribe, event, callback]);
}
